<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; display: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <div class="TS01">
        <div class="position">
          <div style="display: flex; flex-direction: column">
            <step-progress
              :steps="mySteps"
              :current-step="currentStep"
              icon-class="fa fa-check fa-lg"
              v-if="disable == false"
            ></step-progress>
            <div class="display_quiz">
              <div
                v-if="getWidth >= 1025 && disable == false"
                class="icon_arrow"
              >
                <div class="arrow_left" @click="onPrev">
                  <img
                    style="width: 40%; height: 40%"
                    src="@/assets/images/CH2/left-arrow.png"
                    alt=""
                  />
                </div>
              </div>
              <div class="card">
                <div class="container_TS01">
                  <div class="block">
                    <div
                      style="height: auto; display: grid"
                      class="font_setting"
                      v-if="isLoadCompleted"
                    >
                      <div
                        class="audio_card"
                        style="margin-top: 5%"
                        v-if="type === 1"
                      >
                        <p :class="checkLangClass()">
                          {{ checkLanguage(content.title) }}
                        </p>
                        <AudioList
                          :title="`Audio.`"
                          :descrip="``"
                          :play="play"
                          @onPlay="onPlay"
                        />
                      </div>
                      <div v-else>
                        <div class="containerQuestionText">
                          <p :class="checkLangClass()">
                            {{ checkLanguage(content.title) }}
                          </p>
                          <p
                            class="fontChinese"
                            style="
                              text-align: center;
                              margin-top: 5%;
                              font-size: 40px;
                            "
                            v-if="subTitle.length != 0"
                          >
                            {{ checkLanguage(subTitle) }}
                          </p>
                        </div>
                        <div style="grid-row: 3 / 7; margin-top: 1rem">
                          <!-- instruction text here -->
                          <p :class="languageDetector(content.item.data)">
                            {{ content.item.data }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <CRow>
                    <CCol>
                      <div class="flex_between">
                        <div
                          class="button_setting"
                          v-for="(item, index) in choise"
                          :key="index"
                          style="margin-top: 3%"
                        >
                          <CheckBox
                            :text="choise[index]"
                            :index="index"
                            :isCheck="isCheckData"
                            :detectedLanguage="detectedLanguage"
                            @returnIndex="getReturnData"
                          />
                        </div>
                      </div>
                    </CCol>
                  </CRow>
                </div>
              </div>
              <div class="icon_arrow" v-if="getWidth >= 1025">
                <div class="arrow_right" @click="onNext">
                  <img
                    style="width: 40%; height: 40%"
                    src="@/assets/images/CH2/right-arrow.png"
                    alt=""
                  />
                </div>
              </div>
              <div v-else class="menu_btn">
                <div class="btn_prev" v-if="disable == false">
                  <div class="btn_left" @click="onPrev">
                    <div class="font_prev">
                      <b>PREVIOUS</b>
                    </div>
                  </div>
                </div>
                <div class="btn_next">
                  <div class="btn_right" @click="onNext">
                    <div class="font_next">
                      <b>NEXT</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import AudioList from '@/components/elements/audio/AudioList';
import CheckBox from '@/components/elements/Checkbox/Checkbox';
import LoadingMDL from '@/components/loading/LoadingMDL';
import '../../../assets/scss/chinessStyle2.scss';
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';

export default {
  components: {AudioList, CheckBox, LoadingMDL, StepProgress},
  name: 'QZ02',
  props: {},
  data() {
    return {
      choise: [],
      soundPath: '',
      soundObject: undefined,
      isPlay: false,
      play: false,
      type: Number,
      isCheckData: null,
      currentRoute: '',
      isLoadCompleted: false,
      content: [],
      loading: true,
      language: '',
      navigation: [],
      ans: null,
      mySteps: [],
      currentStep: null,
      getWidth: window.innerWidth,
      startTime: '',
      condition: [],
      criteria_id: '',
      disable: false,
      topic: {},
      // code: "605418cb883ae722ba1b0c5f",
      code: '',
      section: '',
      chapter: null,
      detectedLanguage: 'chinese',
      subTitle: [],
      v3Data: null,
      v3Score: 0,
      v3TrueAnswer: null,
    };
  },
  methods: {
    onLoadData() {
      this.loading = true;

      this.currentRoute = this.$route.name + '-' + this.$route.params.id;
      this.courseData = this.$store.getters['necessary/getLerningCourse'];
      this.code = this.courseData._id;
      this.section = this.$store.getters['necessary/getUserCourseSection'];
      this.language = this.$store.getters['language/getLanguage'];

      this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);
    },
    onPlay: function (val) {
      if (val) {
        this.soundObject.pause();
      } else {
        this.soundObject.play();
      }
      this.play = !val;
    },
    onPrev: function () {
      if (this.navigation.previous.action != null) {
        this.play = false;
        if (this.soundObject != undefined) {
          this.soundObject.pause();
          this.soundObject = null;
        }
        // var str = this.navigation.previous.action.split('-');
        // let body = '/' + str[0] + '/' + str[1];
        // if (str[0] == this.$route.name) {
        //   let payload = {
        //     templateCode: this.navigation.previous.action,
        //     // code: "605418cb883ae722ba1b0c5f",
        //     code: this.code,
        //     // section: "testing",
        //     section: this.section,
        //   };
        //   // this.$store.dispatch('template/fetchTemplateAndProgress', payload);
        //   this.$router.push(body);
        //   this.loading = true;
        // } else {
        //   this.$router.push(body);
        // }
        const str = this.navigation.previous.action.split('-');
        const path = `/v3/${str[0]}/${str[1]}`;
        this.$router.push(path);
      }
    },
    onNext: function () {
      if (this.navigation.next.action != null) {
        this.play = false;
        if (this.isCheckData != null) {
          if (this.soundObject != undefined) {
            this.soundObject.pause();
            this.soundObject = null;
          }
          this.commitUserProgress();
        } else {
          alert('please select answer');
        }
      }
    },
    commitUserProgress: function () {
      this.loading = true;
      // let userCriteria = {
      //   code: this.code,
      //   contentId: this.criteria_id,
      //   codeTemplate: this.$route.name + '-' + this.$route.params.id,
      //   answering: [
      //     {
      //       answer: this.choise[this.isCheckData].toLowerCase(),
      //     },
      //   ],
      //   topic: this.topic,
      //   chapter: this.chapter,
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: this.condition,
      // };
      // this.$store.dispatch('template/commitUserProgressChinese2', userCriteria);

      if (this.choise[this.isCheckData] == this.v3TrueAnswer) {
        this.v3Score = 1;
        // console.log('This is correct answer');
      }

      // // ส่วนนี้เป็นส่วนของการบันทึกข้อมูลไปยัง DB โดยส่งข้อมูลไปยัง backend ในรูปแบบนี้โดยไม่ต้องรอค่ารีเทิร์น
      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [
            {
              answer: this.choise[this.isCheckData].toLowerCase(),
            },
          ], // ถ้าหน้าไหนมีแบบฝึกหัดให้เพิ่มส่วนนี้มาด้วย (ต้องอ้างอิงฟอร์มข้ออันเดิม)
          progress: 100,
          score: this.v3Score,
          maxScore: 1,
        },
      ];
      console.log(data, this.v3Score, this.v3Data.codeItem, 'log payload');

      this.$store.dispatch('v3/saveContent', data);
      // //===========================================================

      const str = this.navigation.next.action.split('-');
      const path = `/v3/${str[0]}/${str[1]}`;
      this.$router.push(path);
    },
    checkLangClass() {
      if (this.language == 'CN') {
        return 'fontChinese question_text';
      } else {
        return 'question_text';
      }
    },
    languageDetector: function (text) {
      const allowText = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      try {
        for (let index = 0; index < allowText.length; index++) {
          if (text[0] == allowText[index]) {
            return 'instruction_text';
          }
        }
        return 'fontChinese instruction_text';
      } catch (error) {
        console.log('Warning, parameters is null');
        return 'instruction_text';
      }
    },
    getReturnData: function (val) {
      this.isCheckData = val;
    },
    checkLanguage(val) {
      if (val) {
        try {
          for (let i = 0; i <= val.length; i++) {
            if (val[i].key != null) {
              if (val[i].key.toUpperCase() == this.language) {
                return val[i].value;
              }
            }
          }
        } catch (err) {
          console.log('change language is error 1!!');
        }
      } else {
        console.log('change language is error 2!!');
      }
    },
    setProgress: function (value) {
      return new Promise((resolve, reject) => {
        value.chapter.item.map((i) => {
          switch (i.content.type) {
            case 'topic':
              this.mySteps.push('Topic');
              break;
            case 'flipcard':
              this.mySteps.push('Vocabulary');
              break;
            case 'assignment':
              this.mySteps.push('Assignment');
              break;
            case 'test':
              this.mySteps.push('Test');
              break;
            default:
              this.mySteps.push(i.content.type);
              break;
          }
        });
        this.currentStep = value.topicPosition.index - 1;
        resolve();
      });
    },
    resetLocalState() {
      this.choise = [];
      this.soundPath = '';
      this.soundObject = undefined;
      this.isPlay = false;
      this.play = false;
      this.type = Number;
      this.isCheckData = null;
      this.currentRoute = '';
      this.isLoadCompleted = false;
      this.content = [];
      this.ans = null;
      this.mySteps = [];
      this.currentStep = null;
      this.startTime = '';
      this.condition = [];
      this.criteria_id = '';
      this.getWidth = window.innerWidth;
      this.disable = false;
      this.topic = {};
      this.chapter = null;
      this.v3Score = 0;
    },
  },
  computed: {
    ...mapGetters({
      // getTemplateAndProgress: 'template/getTemplateAndProgress',
      // getResponseStatus: 'template/getResponseStatus',
      storeLanguage: 'language/getLanguage',
      getTemplatev3: 'v3/getTemplates',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      const template = val.templates[0];
      this.content = template.content.item[0];
      this.subTitle = template.subTitle;
      this.navigation = template.navigate;

      this.type = template.content.item[0].media.length == 0 ? 2 : 1;
      //
      let storeChoice = [];
      for (let i = 0; i < template.content.item[0].choices.length; i++) {
        if (template.content.item[0].choices[i].question != null) {
          storeChoice.push(template.content.item[0].choices[i].question);

          if (template.content.item[0].choices[i].answer == 'TRUE') {
            //เก็บข้อที่ถูกต้อง
            this.v3TrueAnswer = template.content.item[0].choices[i].question;
          }
        }
      }
      //
      if (this.type != 2) {
        this.soundPath =
          'https://mdl.mfu.ac.th/' + template.content.item[0].media[0].url;
        this.soundObject = new Audio(this.soundPath);
      }
      this.choise = storeChoice;
      let splited = this.choise[0].split('. ');
      const ALLOWTEXT = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
      ];
      ALLOWTEXT.forEach((element) => {
        try {
          if (splited[1][0] == element) {
            this.detectedLanguage = 'english';
          }
        } catch (err) {
          this.detectedLanguage = 'chinese';
        }
      });
      this.isLoadCompleted = true;

      this.loading = false;
    },
    '$route.params.id'() {
      //use to watch param id if changes
      //clear old state and Load new data
      this.loading = true;

      this.resetLocalState();
      this.onLoadData();
    },
    // getTemplateAndProgress: async function (value) {
    //   this.mySteps = [];
    //   let templateType = ['pretest', 'posttest'];
    //   this.disable = templateType.includes(value.topicPosition.type);
    //   this.subTitle = value.templateData.subTitle;
    //   this.startTime = this.$helpers.getDateFormat();
    //   if (value.criteria.condition.criteriaType.length != 0) {
    //     this.condition.push({
    //       criteria: value.criteria.condition.criteriaType[0]._id,
    //       val: value.criteria.condition.criteriaType[0].val,
    //     });
    //   }
    //   this.criteria_id = value.criteria._id;
    //   this.chapter = value.chapter;
    //   this.topic = value.topicPosition;
    //   this.content = value.templateData.content.item[0];
    //   this.navigation = value.templateData.navigate;
    //   this.type = value.templateData.content.item[0].media.length == 0 ? 2 : 1;
    //   let storeChoice = [];
    //   for (
    //     let i = 0;
    //     i < value.templateData.content.item[0].choices.length;
    //     i++
    //   ) {
    //     if (value.templateData.content.item[0].choices[i].question != null) {
    //       storeChoice.push(
    //         value.templateData.content.item[0].choices[i].question
    //       );
    //     }
    //   }
    //   if (this.type != 2) {
    //     this.soundPath =
    //       'https://mdl.mfu.ac.th/' +
    //       value.templateData.content.item[0].media[0].url;
    //     this.soundObject = new Audio(this.soundPath);
    //   }
    //   this.choise = storeChoice;
    //   let splited = this.choise[0].split('. ');
    //   const ALLOWTEXT = [
    //     'A',
    //     'B',
    //     'C',
    //     'D',
    //     'E',
    //     'F',
    //     'G',
    //     'H',
    //     'I',
    //     'J',
    //     'K',
    //     'L',
    //     'M',
    //     'N',
    //     'O',
    //     'P',
    //     'Q',
    //     'R',
    //     'S',
    //     'T',
    //     'U',
    //     'V',
    //     'W',
    //     'X',
    //     'Y',
    //     'Z',
    //     'a',
    //     'b',
    //     'c',
    //     'd',
    //     'e',
    //     'f',
    //     'g',
    //     'h',
    //     'i',
    //     'j',
    //     'k',
    //     'l',
    //     'm',
    //     'n',
    //     'o',
    //     'p',
    //     'q',
    //     'r',
    //     's',
    //     't',
    //     'u',
    //     'v',
    //     'w',
    //     'x',
    //     'y',
    //     'z',
    //   ];
    //   ALLOWTEXT.forEach((element) => {
    //     try {
    //       if (splited[1][0] == element) {
    //         this.detectedLanguage = 'english';
    //       }
    //     } catch (err) {
    //       this.detectedLanguage = 'chinese';
    //     }
    //   });
    //   this.isLoadCompleted = true;
    //   if (!this.disable) {
    //     await this.setProgress(value);
    //   }
    //   this.loading = false;
    // },
    // function Check lang en-ch
    // getResponseStatus: function (val) {
    //   if (val.status == 200) {
    //     let str = this.navigation.next.action.split('-');
    //     let body = '/' + str[0] + '/' + str[1];
    //     if (str[0] == this.$route.name) {
    //       this.choise = [];
    //       this.soundPath = '';
    //       this.soundObject = undefined;
    //       this.isPlay = false;
    //       this.play = false;
    //       this.type = Number;
    //       this.isCheckData = null;
    //       this.currentRoute = '';
    //       this.isLoadCompleted = false;
    //       this.content = [];
    //       this.ans = null;
    //       this.mySteps = [];
    //       this.currentStep = null;
    //       this.startTime = '';
    //       this.condition = [];
    //       this.criteria_id = '';
    //       this.getWidth = window.innerWidth;
    //       this.disable = false;
    //       this.topic = {};
    //       this.chapter = null;

    //       let payload = {
    //         templateCode: this.navigation.next.action,
    //         code: this.code,
    //         section: this.section,
    //       };
    //       this.$store.dispatch('template/fetchTemplateAndProgress', payload);
    //       if (this.disable) {
    //         this.$router.replace(body);
    //       }
    //       this.$router.push(body);
    //       this.loading = true;
    //     } else {
    //       this.$router.push(body);
    //     }
    //   }
    // },
    storeLanguage: function (value) {
      this.language = value;
    },
  },
  created() {
    // console.log(this.section);
    // this.getTemplateAndProgress();
  },
  mounted() {
    // let payload = {
    //   templateCode: this.currentRoute,
    //   code: this.code,
    //   section: this.section,
    // };
    // this.$store.dispatch('template/fetchTemplateAndProgress', payload);
    this.onLoadData();
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
* {
  user-select: none;
}

::v-deep .step-progress__wrapper {
  width: 75%;
}

::v-deep .step-progress__wrapper-before {
  top: 45%;
  height: 10px;
  opacity: 0.5;
  background-color: #3b3b38 !important;
}

::v-deep .step-progress__step--valid:after {
  background-color: #1d5bd7;
}

::v-deep .step-progress__step--valid:after {
  border: #1d5bd7 solid !important;
}

::v-deep .step-progress__step--active:after {
  border: #1d5bd7 solid !important;
}

::v-deep .step-progress__step--active .step-progress__step-label,
.step-progress__step--active span {
  color: #1d5bd7;
}

::v-deep .step-progress__wrapper-after {
  top: 45%;
  height: 10px;
  background-color: #1d5bd7 !important;
  opacity: 0.5;
}

::v-deep .step-progress__step span {
  font-size: 0px;
}

::v-deep svg:not(:root).svg-inline--fa {
  width: 20px;
  height: 20px;
}

::v-deep .step-progress__step-label {
  top: -50px;
}

::v-deep .step-progress__step--valid .step-progress__step-label {
  color: #1d5bd7;
}

::v-deep .step-progress__step:after {
  width: 40px;
  height: 40px;
  border: #808080 solid;
}

::v-deep .step-progress__bar {
  margin-bottom: 10px;
}

.display_quiz {
  display: flex;
  flex-direction: row;
}

.font_prev {
  color: #1d5bd7;
  font-size: 16px;
}

.font_next {
  color: white;
  font-size: 16px;
}

.btn_prev {
  margin-right: 5%;
  margin-left: 5%;
  margin-top: 5%;
}

.btn_next {
  margin-right: 5%;
  margin-left: 5%;
  margin-top: 5%;
}

.btn_left {
  width: 100px;
  height: 50px;
  border-radius: 10px;
  background-color: #e6efff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn_right {
  width: 100px;
  height: 50px;
  border-radius: 10px;
  background-color: #1d5bd7;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu_btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.TS01 {
  background-color: #ffccd5;
  padding-bottom: 5%;
  padding-top: 5%;
}

.position {
  display: flex;
  align-content: center;
  justify-content: center;
  padding-top: 3%;
  padding-bottom: 8%;
}

.icon_arrow {
  margin: auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 2%;
  margin-right: 2%;
}

.arrow_left,
.arrow_right {
  width: 60px;
  height: 60px;
  background-color: #e6efff;
  cursor: pointer;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.question_text {
  font-size: 22px;
  text-align: left;
  width: auto;
  height: auto;
}

.instruction_text {
  font-size: 44px;
  text-align: left;
  width: auto;
  height: auto;
  text-align: center;
}

.card {
  background-color: white;
  width: 1000px;
  height: 100%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 30px;
  /* 5px rounded corners */
  padding-top: 50px;
}

.block {
  height: auto;
  margin: 0;
  border-radius: 7px;
}

.font_setting {
  height: auto;
  width: 100%;
  display: flex;
  border-radius: 10px;
  background-color: #e6efff;
}

.container_TS01 {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.detail_question {
  height: auto;
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex_between {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-bottom: 5%;
  margin-left: -3%;
  margin-right: -2.5%;
}

.button_setting {
  width: 45%;
  height: 60px;
  color: black;
  margin-top: 10px;
  cursor: pointer;
  font-size: 15px;
  border-radius: 15px !important;
}

.ContentProgressBar {
  display: flex;
  justify-content: center;
}

.ProgressBar {
  background-color: #e6efff !important;
  margin-top: 3%;
  margin-bottom: 3%;
  width: 100%;
  height: 10px;
  border-radius: 10px !important;
}

.progress-bar-striped {
  background-image: none !important;
}

.audio_card {
  margin: 4rem 2rem;
}

.containerQuestionText {
  grid-row: 1 / 3;
  margin: 2rem 2rem;
}

@media only screen and (min-width: 280px) and (max-width: 600px) {
  .container {
    margin-top: 20px;
  }

  .question_text {
    font-size: 20px;
  }

  .position {
    padding-top: 15%;
  }

  .block {
    height: auto;
  }

  .listen {
    width: auto;
  }

  ::v-deep .step-progress__wrapper {
    width: 85%;
  }

  .display_quiz {
    flex-direction: column;
  }

  .size_image {
    width: 40%;
    height: 40%;
  }

  .font_prev {
    font-size: 16px;
  }

  .font_next {
    font-size: 16px;
  }

  .audio_card {
    margin: 20px;
  }

  .instruction_text {
    font-size: 36px;
    text-align: left;
    width: auto;
    height: auto;
    margin-left: 18px;
  }

  .TS01 {
    background-color: #ffccd5;
    padding-top: 10%;
    padding-bottom: 10%;
    display: flex;
    align-content: center;
    justify-content: center;
  }

  .position {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
  }

  .ContentProgressBar {
    display: flex;
    justify-content: center;
    padding-top: 20px;
  }

  .flex_between {
    margin-left: 0;
    margin-right: 0;
  }

  .icon_arrow {
    margin-top: 2%;
  }

  .arrow_left {
    width: 100px;
    height: 50px;
    border-radius: 10px;
  }

  .arrow_right {
    width: 100px;
    height: 50px;
    border-radius: 10px;
  }

  .ProgressBar {
    background-color: #e6efff !important;
    margin-top: 3%;
    margin-bottom: 10%;
    width: 100%;
    height: 10px;
    border-radius: 10px !important;
  }

  .button_setting {
    width: 100% !important;
    height: 60px !important;
  }

  .card {
    width: 350px;
    border-radius: 20px;
    height: auto !important;
    padding-top: 20px;
  }

  .detail_question {
    height: 90%;
  }

  .containerQuestionText {
    grid-row: 1 / 3;
    margin: 2rem 1rem;
  }

  .question_text {
    width: 100%;
    height: auto;
    font-weight: bold;
    margin-bottom: 0;
    font-size: 24px;
  }

  .arrow_left {
    margin-left: 10px;
  }

  .arrow_right {
    margin-right: 10px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 769px) {
  .card {
    width: 600px;
    margin-bottom: 0;
  }

  .TS01 {
    background-color: #ffccd5;
    padding-bottom: 10%;
    display: flex;
    align-content: center;
    justify-content: center;
  }

  .position {
    padding-top: 20%;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
  }

  ::v-deep .step-progress__wrapper {
    width: 85%;
  }

  .btn_left {
    width: 150px;
    height: 50px;
    border-radius: 10px;
    background-color: #e6efff;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btn_right {
    width: 150px;
    height: 50px;
    border-radius: 10px;
    background-color: #1d5bd7;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .question_text {
    margin-bottom: 0;
    font-size: 26px;
    font-weight: bold;
  }

  .display_quiz {
    flex-direction: column;
  }
}

@media only screen and (min-width: 1023px) and (max-width: 1024px) {
  .card {
    width: 900px;
    margin-bottom: 0;
  }

  ::v-deep .step-progress__wrapper {
    width: 85%;
  }

  .TS01 {
    background-color: #ffccd5;
    padding-bottom: 10%;
    display: flex;
    align-content: center;
    justify-content: center;
  }

  .position {
    padding-top: 5%;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
  }

  .btn_left {
    width: 150px;
    height: 50px;
  }

  .btn_right {
    width: 150px;
    height: 50px;
  }

  .question_text {
    margin-bottom: 0;
    font-size: 26px;
    font-weight: bold;
  }

  .display_quiz {
    flex-direction: column;
  }
}

/* Add rounded corners to the top left and the top right corner of the image */
</style>
